import React, { Component, Fragment } from 'react';

import selectArrow from 'images/select-arrow.svg';

class ThemeDetails extends Component {
  accepThemeDetails = e => {
    const { accepThemeDetails } = this.props;
    const { value } = e.target;
    let body = {};
    if (value !== 'custom') {
      body.theme_id = value;
    }

    accepThemeDetails(body);
  };

  handleChangeFooter = e => {
    const { acceptShowFooter } = this.props;
    acceptShowFooter(e.target.checked);
  };

  renderOptions = () => {
    const { options, subscribed } = this.props;
    return (
      <Fragment>
        {options.map(el => (
          <option key={el.id} value={el.id.toString()}>
            {el.name}
          </option>
        ))}
        {subscribed ? <option value={'custom'}>Custom</option> : null}
      </Fragment>
    );
  };

  render() {
    const { optionDefaultValue, showFooterValue } = this.props;
    return (
      <Fragment>
        <h2 className="h2-title">Theme details</h2>
        <div className="separator-line m-b-40" />
        <div className="style-form m-b-30">
          <div className="style-form__row">
            <div className="style-form__col">
              <div className="style-form__subtitle top">Current theme</div>
              <div className="select-wrap outline space-between">
                <select
                  className="select appearance-none form-control"
                  onChange={this.accepThemeDetails}
                  value={optionDefaultValue}>
                  {this.renderOptions()}
                </select>
                <div className="select-wrap__icon">
                  <img src={selectArrow} alt="" />
                </div>
              </div>
            </div>
            <div className="style-form__col">
              <div className="switch-block middle">
                <div className="switch-block__text">Show footer</div>
                <div className="checkbox-switch">
                  <input
                    name="profilesWithContacts"
                    type="checkbox"
                    className="checkbox-switch__input"
                    checked={showFooterValue}
                    onChange={this.handleChangeFooter}
                    id="show-footer-theme-details"
                  />
                  <label
                    htmlFor="show-footer-theme-details"
                    className="checkbox-switch__label"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ThemeDetails;



// WEBPACK FOOTER //
// ./src/scenes/Styles/ThemeDetails.js